export var wait = function wait(milli) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, milli);
  });
};
export var wrapWithRetry = function wrapWithRetry(validator, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$timeout = _options.timeout,
      timeout = _options$timeout === void 0 ? 500 : _options$timeout,
      _options$retriesCount = _options.retriesCount,
      retriesCount = _options$retriesCount === void 0 ? 100 : _options$retriesCount;

  if (validator()) {
    return Promise.resolve();
  } else {
    if (retriesCount === 0) {
      return Promise.reject();
    }

    return wait(timeout).then(function () {
      return wrapWithRetry(validator, {
        retriesCount: retriesCount - 1,
        timeout: timeout
      });
    });
  }
};